import React from 'react';
import {Box, IconButton} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {PlayButton} from '@jobseeker/lotus/assets/icons';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

interface VideoThumbnailProps {
  thumbnailUrl: string;
  title?: string;
  width: number;
  height: number;
  onClick: () => void;
  borderRadius?: string;
}

const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const VideoThumbnail: React.FC<VideoThumbnailProps> = ({
  thumbnailUrl,
  title,
  width,
  height,
  onClick,
  borderRadius = '10px',
}) => {
  // Extract YouTube thumbnail if it's a YouTube URL
  function getYouTubeThumbnail(url: string, quality: string = 'hqdefault') {
    // Supported qualities: default, mqdefault, hqdefault, sddefault, maxresdefault
    const regexList = [
      /v=([^&]+)/, // normal YouTube URL
      /youtu\.be\/([^?]+)/, // short URL
      /embed\/([^?]+)/, // embed URL
      /shorts\/([^?]+)/, // shorts URL
    ];

    let videoId: string | undefined;

    for (const regex of regexList) {
      const match = url.match(regex);
      if (match) {
        videoId = match[1];
        break;
      }
    }

    if (!videoId) {
      return 'https://img.youtube.com/vi/default.jpg';
    }

    return `https://img.youtube.com/vi/${videoId}/${quality}.jpg`;
  }
  const isMediumDevice = useIsLargeDevice(900);
  const isextralarge = useIsLargeDevice(1400);

  return (
    <Box
      width={isextralarge && isAppIimjobs ? 314 : isMediumDevice ? 300 : 168}
      height={isMediumDevice ? 180 : 106}
      sx={{
        position: 'relative',
        borderRadius,
        overflow: 'hidden',
      }}
    >
      <Image
        src={getYouTubeThumbnail(thumbnailUrl)}
        alt={title || 'Video thumbnail'}
        width={width}
        height={height}
        style={{
          borderRadius,
        }}
      />

      {/* Play Button Overlay */}
      <Box
        className="play-overlay"
        sx={{
          position: 'absolute',

          right: {xxs: 0, xl: 12},
          bottom: 0,
          display: 'flex',

          transition: 'all 0.3s ease',
          borderRadius,
        }}
      >
        <IconButton className="play-button" sx={{cursor: 'pointer'}}>
          <Image
            onClick={onClick}
            height={32}
            width={32}
            alt=""
            src={PlayButton}
          />
        </IconButton>
      </Box>
    </Box>
  );
};

export default VideoThumbnail;
